//Login & Registration
export const REST_API_LOGIN_URL = "account/login";
export const REST_API_LOGIN_URL_CANDIDATE = "account/login/candidate";
export const REST_API_LOGIN_URL_ORGANIZATION = "account/login/organization";
export const REST_API_LOGIN_URL_RECRUITER = "account/login";
export const REST_API_LOGIN_URL_ADMIN = "account/login/admin";
export const REST_API_JOB_PORTAL_CANDIDATE = "security/registercode";

export const REST_API_REGISTRATION_URL = "account/registrationprocess";
export const REST_API_SET_PASSWORD_URL = "account/setpassword";
export const REST_API_FORGOT_PASSWORD_URL = "account/sendpasswordresetlink";
export const REST_API_FORGOT_PASSWORD_URL_ORGANIZATION =
  "account/sendpasswordresetlink/organization";
export const REST_API_FORGOT_PASSWORD_URL_RECRUITER =
  "account/sendpasswordresetlink/recruiter";
export const REST_API_FORGOT_PASSWORD_URL_CANDIDATE =
  "account/sendpasswordresetlink/candidate";
export const REST_API_VERIFY_MAIL_URL = "account/verficationprocess";
export const REST_API_DETAIL_SET = "security/profile";
export const REST_API_SOCIAL_LOGIN_GOOGLE = "account/googleloginprocess";
export const REST_API_SOCIAL_LOGIN_GOOGLE_ORGANIZATION =
  "account/googleloginprocess/organization";
export const REST_API_SOCIAL_LOGIN_GOOGLE_RECRUITER =
  "account/googleloginprocess/recruiter";
export const REST_API_SOCIAL_LOGIN_GOOGLE_ADMIN =
  "account/googleloginprocess/admin";
export const REST_API_SOCIAL_LOGIN_GOOGLE_CANDIDATE =
  "account/googleloginprocess/candidate";
export const REST_API_SOCIAL_SIGNUP_GOOGLE = "account/googlesignupprocess";
export const REST_API_RESET_PASSWORD_VERIFY_CODE =
  "account/verifyforgotpasswordcode";
export const REST_API_UPDATE_PASSWORD = "password";
export const REST_API_SOCIAL_LOGIN_MICROSOFT = "account/microsoftloginprocess";
export const REST_API_SOCIAL_SIGNUP_MICROSOFT =
  "account/micorsoftsignupprocess";

//Candidate Management
export const REST_API_GET_CANDIDATE_LIST = "candidate/list";
export const REST_API_GET_MAPPED_CANDIDATE_LIST =
  "organization/mappedcandidate/";
export const REST_API_GET_CANDIDATE_COUNT =
  "organization/candidate/candidatescount";
export const REST_API_BULKIMPORT = "candidate/resumebulkimport";
//Job Management
export const REST_API_GET_JOB_LIST = "job/list?";
export const REST_API_GET_JOB_COUNT = "organization/job/jobscount";
export const REST_API_JOB_BULKIMPORT = "job/jobbulk";
export const REST_API_ADD_NEW_JOB = "job";
export const REST_API_GET_JOB_DATA = "job?id=";
export const REST_API_UPDATE_JOB = "job";
export const REST_API_DELETE_JOB = "organization/job/deletejob";

export const REST_API_GET_JOB_STATUS = "jobtarget/main/job/update?id=";
export const REST_API_ADD_DISTRIBUTE_JOB = "jobtarget/main/job/create?id=";
export const REST_API_GET_JOB_STATS = "jobtarget/main/jobDetailsByJobId?id=";

//unzip files
export const REST_API_BULKIMPORTUNZIP = "candidate/bulkimportunzip";
export const REST_API_RECRUITER_BULKIMPORTUNZIP = "candidate/bulkimportUnzip";
//Profile Detail

export const REST_API_UPDATE_PROFILE_DETAIL = "security/updatedetail";
export const REST_API_GET_PROFILE_DETAIL = "security/profile";

//admin dashboard
export const REST_API_GET_ADMIN_DASHBSHBOARD_CARDS_DATA = "admin/dashboard";
export const REST_API_GET_MONTHLY_CLIENTS_DATA = "admin/dashboard/month";
export const REST_API_GET_YEARLY_CLIENTS_DATA = "admin/dashboard/year/client";
export const REST_API_GET_YEARLY_CLIENTS_REG_DATA = "admin/dashboard/year";
export const REST_API_GET_ACTIVE_AND_INACTIVE_DATA = "admin/dashboard/active";
export const REST_API_GET_WORLD_MAP_DATA = "admin/dashboard/map";

//new clients
export const REST_API_GET_NEW_CLIENTS_LIST = "admin/report/newclient";
//active clients
export const REST_API_GET_ACTIVE_CLIENTS_LIST = "admin/report/activeclient";

//report page
export const REST_API_GET_ADMIN_REPORT_LIST = "admin/feedback";
export const REST_API_GET_CHAT_MODAL_DATA = "admin/reportIssue";

//client issues
export const REST_AP_GET_REPORT_CHAT_LIST = "feedback";
export const REST_AP_GET_DELETE_Ticket = "admin/reportIssue";
//report feedback
export const REST_API_REPORT_ISSUE = "feedback";

//candidateInterest feedback
export const REST_API_CANDIDATEINTEREST = "account/feedback/job/interest";

//assesssment test

export const REST_API_ASSESSMENT_TEST = "account/feedback/candidate/assessment";

//offer page details
export const REST_API_DOCUMENTS_DATA = "recruitment/verification/document/list";

//Ai markup
export const REST_API_POST_AI_MARKUP_DATA = "ai/markup";
export const REST_API_GET_AI_MARKUP_DATA = "ai/markup";

export const REST_API_GET_CALENDAR_DATA = "candidate/dashboard/interview?";
export const REST_API_GET_VACANCY_DATA = "";
export const REST_API_POST_RECOMMENDED_JOBS_DATA = "candidate/dashboard/jobs";
export const REST_API_POST_JOB_STATUS_DATA = "candidate/dashboard/job/status";

//search candidate
export const REST_API_SEARCH_CANDIDATE_LIST =
  "organization/candidate/searchcandidatelist";
export const REST_API_SEARCH_CANDIDATE_COUNT =
  "organization/candidate/searchcandidatescount";

//manageassesments
export const REST_API_GET_ASSESSMENT_LIST = "configuration/assessment";
export const REST_API_GET_QUESTIONBANK_LIST =
  "configuration/assessment/questionBank";

//screening questions
export const REST_API_SCREENING_GET_QUESTIONBANK_LIST =
  "recruitment/screen/question";
export const REST_API_SCREENING_POST_QUESTIONBANK =
  "recruitment/screen/question/job";

//Candidate Operation
export const REST_API_ADD_NEW_CANDIDATE = "candidate";
export const REST_API_ADD_DELETE_CANDIDATE =
  "organization/candidate/deletecandidate";
export const REST_API_CHECK_DUPLICATE_CANDIDATE =
  "candidate/candidateDuplicationCheck";
export const REST_API_UPDATE_CANDIDATE = "candidate";
export const REST_API_GET_CANDIDATE_DATA = "candidate";
//get location ,state and ip location
export const REST_API_GET_COUNTRIES = "account/getCountry";
export const REST_API_GET_STATE = "account/getState?SelectedCountry=";
export const REST_API_GET_STATE_AND_COUNTRY = "account/location";
export const REST_API_POST_ACCOUNT_SWITCH = "accountSwitch/switch";

export const REST_API_GET_IP_LOCATION = "geolocation-db.com/json/";
export const REST_API_GET_VALIDATE_URL =
  "configuration/careerpage/validate/url?url=";
//Matching jobs and candidates
export const REST_API_GET_MATCHING_JOBS = "organization/matchingJobs";
export const REST_API_GET_RECRUITER_MATCHING_JOBS = "recruiter/matchingJobs";
export const REST_API_JOB_DETAIL = "job?id=";
export const REST_API_GET_COUNTRY_AND_STATE = "account/location?city=";

//my team
export const REST_API_GET_USERS_LIST = "config/team";
export const REST_API_GET_ALL_USERS_LIST = "config/listteam";
export const REST_API_MYTEAM_UPDATE_USER_GET = "config/team/user";
export const REST_API_MYTEAM_UPDATE_USER_POST = "config/team/user/update";
export const REST_API_MYTEAM_ADD_NEW_USER_POST = "config/team/user";
export const REST_API_MYTEAM_ALL_ROLES = "config/team/roles";
export const REST_API_DELETE_USER_DELETE = "myteam/delete/deleteuser";
export const REST_API_ISACTIVE = "config/team/user/status?userId=";
export const REST_API_RESEND_VERIFICATION_EMAIL =
  "config/team/user/sendEmail/verification";

//notification
export const REST_API_GET_ORGANIZATION_NOTIFICATIONS = "notification";
export const REST_API_UPDATE_ORGANIZATION_NOTIFICATIONS =
  "notification/process/setViewed";

//EmailContent
export const REST_API_EMAIL_CONTENT = "superadmin/emailcontent";
export const REST_API_EMAIL_CONTENT_UPDATE_POST =
  "superadmin/emailcontent/updateemail";
export const REST_API_EMAIL_CONTENT_UPDATE_GET =
  "superadmin/emailcontent/getemail";
export const REST_API_EMAIL_CONTENT_ADD_POST =
  "superadmin/emailcontent/addemail";
export const REST_API_EMAIL_DUMMY_SEND = "superadmin/emailcontent/sendemail/";

//settings
export const REST_API_GET_SETTINGS_LIST = "superadmin/setting/list";
export const REST_API_UPDATE_SETTINGS_GET = "superadmin/setting/getsetting";
export const REST_API_UPDATE_SETTINGS_POST = "superadmin/setting/Updatesetting";
export const REST_API_ADD_SETTINGS_POST = "superadmin/setting/addsetting";

//acl
export const REST_API_ACL_GET_ALL_ROLES = "acl/role/getall";
export const REST_API_ACL_UPDATE_ROLE = "acl/role/update";
export const REST_API_ACL_GET_ALL_PERMISSIONS = "acl/permission/getall";
export const REST_API_ACL_UPDATE_PERMISSION = "acl/permission/update";
export const REST_API_ACL_GET_ALL_PERMISSION_ROLE_MAPPINGS =
  "acl/permissionrolemapping/getall";
export const REST_API_ACL_UPDATE_ALL_PERMISSION_ROLE_MAPPINGS =
  "acl/permissionrolemapping/updateall";

//search job
export const REST_API_SEARCH_JOB_LIST = "organization/searchjoblist";
export const REST_API_SEARCH_JOB_COUNT = "organization/searchjobscount";
//similar candidate
export const REST_API_SIMILAR_CANDIDATE = "organization/similarCandidate";
export const REST_API_RECRUITER_SIMILAR_CANDIDATE =
  "recruiter/similarCandidate";
export const REST_API_SIMILAR_CANDIDATE_DETAIL = "candidate?id=";
export const REST_API_CANDIDATE_ACTIVE_LOG = "candidate/timeline";

// candidate Job Mapping
export const REST_API_CANDIDATE_JOB_MAPPING =
  "organization/candidate/candidatejobmapping";
export const REST_API_GET_CANDIDATE_JOB_MAPPING =
  "organization/candidate/getcandidatejobmapping";
export const REST_API_DELETE_CANDIDATE_JOB_MAPPING =
  "organization/candidate/deletecandidatejobmapping";

//Job operations
export const REST_API_GET_MATCHING_CANDIDATE =
  "organization/job/matchingcandidate";
export const REST_API_GET_SIMILAR_JOB = "organization/job/similarjob";

export const REST_API_GET_JOB_CANDIDATE_MAPPING = "/process/candidate";
// 'job/mappedcandidate?id='
export const REST_API_DELETE_JOB_CANDIDATE_MAPPING =
  "organization/job/deletejobcandidatemapping";

// get Nationality
export const REST_API_GET_NATIONALITY = "candidate/getnationality";
//Qualification List
export const REST_API_GET_QUALIFICATION = "job/basicdetail";

//Candidate Management
export const REST_API_CANDIDATERESUMEUPLOAD = "security/resumeprocess";
export const REST_API_CANDIDATEDETAIL = "security/getdetail";
export const REST_API_UPDATE_DETAIL_CANDIDATE = "candidate";
export const REST_API_CANDIDATE_MYJOBS_FETCH = "candidate/myjobs";
export const REST_API_CANDIDATE_UPDATE_MY_JOB = "candidate/myjobs/job/status";
export const REST_API_MY_JOBS_GET_JOB_DATA = "candidate/myjobs/job";
export const REST_API_CANDIDATE_JOBANALYSIS_DATA =
  "candidate/myjobs/job/analysis?jobId=";
export const REST_API_CANDIDATE_GET_JOB_TYPE_DATAILS =
  "candidate/myjobs/job/status?jobId=";
export const REST_API_CANDIDATE_VIDEO_RESUME = "account/candidate/resume/video";

//Recruiter Management
export const REST_API_RECRUITER_ADD_ORGANIZATION =
  "recruiter/company/addcompany";
export const REST_API_RECRUITER_GET_ORGANIZATION_DETAIL =
  "recruiter/company/getorganizationdetail";
export const REST_API_RECRUITER_UPDATE_ORGANIZATION_DETAIL =
  "recruiter/company/update";
export const REST_API_RECRUITER_ORGANIZATION_LIST = "recruiter/company/list";
export const REST_API_RECRUITER_ORGANIZATION_DELETE =
  "recruiter/company/delete";
export const REST_API_RECRUITER_DETAIL = "security/detailprocess";
export const REST_API_RECRUITER_UPDATE_PROFILE_DETAIL = "security/updatedetail";
export const REST_API_RECRUITER_GET_PROFILE_DETAIL =
  "security/profiledetail?id=";

//Recruiter Candidate
export const REST_API_SEARCH_RECRUITER_CANDIDATE_LIST =
  "recruiter/candidate/searchcandidatelist";
export const REST_API_SEARCH_RECRUITER_CANDIDATE_COUNT =
  "recruiter/candidate/searchcandidatescount";
export const REST_API_RECRUITER_ADD_NEW_CANDIDATE =
  "recruiter/candidate/addcandidate";
export const REST_API_RECRUITER_UPDATE_CANDIDATE =
  "recruiter/candidate/updatecandidate";
export const REST_API_RECRUITER_CHECK_DUPLICATE_CANDIDATE =
  "recruiter/candidate/candidateDuplicationCheck";
export const REST_API_GET_RECRUITER_CANDIDATE_DATA =
  "recruiter/candidate/candidatedata";
export const REST_API_RECRUITER_ADD_DELETE_CANDIDATE =
  "recruiter/candidate/deletecandidate";
export const REST_API_GET_RECRUITER_CANDIDATE_LIST =
  "recruiter/candidate/candidatelist";
export const REST_API_GET_RECRUITER_CANDIDATE_COUNT =
  "recruiter/candidate/candidatescount";
export const REST_API_RECRUITER_BULKIMPORT = "candidate/candidatebulkimport";

//Dashboard
export const REST_API_GET_PUBLISHED_JOBS = "dashboard/job/jobprofile";
export const REST_API_GET_RECRUITMENT_DATA = "dashboard/candidate/flow";
export const REST_API_GET_DASHBOARD_CARDS_DATA = "dashboard/stats";
export const REST_API_GET_DASHBOARD_TOTALINTERVIEW_DATA =
  "recruitment/interview/count";
export const REST_API_GET_NEW_CANDIDATE_DATA =
  "organization/dashboard/candidate/allcandidate?reportType=";
export const REST_API_GET_RECRUITMENT_REPORT = "dashboard/job/analytics";
export const REST_API_GET_DB_JOB_STATUS = "dashboard/job/status";
export const REST_API_GET_DB_SEARCH_JOB_STATUS = "dashboard/job/status/search";
export const REST_API_GET_DB_FILTER_JOB_STATUS = "dashboard/job/status/filter";
export const REST_API_GET_DB_UPCOMING_INTERVIEWS = "recruitment/interview";
export const REST_API_GET_DB_SEARCH_UPCOMING_INTERVIEWS =
  "dashboard/upcoming/interview/search";
export const REST_API_GET_DB_FILTER_UPCOMING_INTERVIEWS =
  "recruitment/interview";
export const REST_API_GET_Job_COMPLETE_STATUS = "job/completion";
export const REST_API_UPDATE_INTERVIEW = "recruitment/interview/update";
export const REST_API_GET_UPCOMING_INTERVIEWS_SUGGESTIONS =
  "dashboard/upcoming/interview/autoComplete/jobProfile";
export const REST_API_GET_JOBSTATUS_SUGGESTIONS =
  "dashboard/job/status/autoComplete/jobProfile";

//Recruitment agency bar chart

export const REST_API_GET_CLIENT_JOBS = "recruiter/dashboard/client/jobs";

export const REST_API_GET_CANDIDATE_HIRE = "recruiter/dashboard/candidate/hire";

//Job
export const REST_API_RECRUITER_ADD_JOB = "recruiter/job";
export const REST_API_RECRUITER_GET_JOB_DATA = "recruiter/job/getjobdata";
export const REST_API_RECRUITER_UPDATE_JOB = "recruiter/job";
export const REST_API_GET_RECRUITER_JOB_DELETE = "recruiter/job/deletejob";
export const REST_API_RECRUITER_JOB_COUNT = "recruiter/job/jobcount";
export const REST_API_GET_RECRUITER_JOB_LIST = "recruiter/job/joblist";
export const REST_API_SEARCH_RECRUITER_JOB_LIST = "recruiter/job/searchjoblist";
export const REST_API_SEARCH_RECRUITER_JOB_COUNT =
  "recruiter/job/searchjobcount";
export const REST_API_RECRUITER_JOB_BULKIMPORT = "recruiter/job/jobbulkimport";
export const REST_API_AUTO_COMPLETE_PROFILE = "account/taxonomy/autocomplete";
export const REST_API_PARSE_RESUME = "parse/resumeBinary";
export const REST_API_PARSE_JD = "parse/jdBinary";
export const REST_API_GET_JOB_PROTILES = "job/repository?page=";
export const REST_API_GET_CANDIDATE_RESUME_STATUS =
  "candidate/resumeimport/status?id=";
export const REST_API_GET_JOB_DESCRIPTION_STATUS = "job/jobimport/status?id=";
export const REST_API_GET_DELETE_JD_LIST = "job/repository/delete?id=";
export const REST_API_GET_JOB_PROFILE_SUGGESTION =
  "job/bulkimport/suggestion/jobProfile?keyword=";
export const REST_API_GET_JD_CSV_FILE = "job/sample/csv";
export const REST_API_GET_RESUME_CSV_FILE = "candidate/sample/csv";

export const REST_API_GET_JOBS_BY_LIST_RECRUITER =
  "recruiter/job/open?pageSize=";

export const REST_API_GET_JOBS_BY_LIST = "job/open?pageSize=";
export const REST_API_GET_JOBS_BY_FILTER = "job/open/filter?pageSize=";
export const REST_API_GET_JOBS_BY_SEARCH = "job/open/search?pageSize=";

export const REST_API_GET_CLOSE_JOBS_BY_LIST_RECRUITER =
  "recruiter/job/closed?pageSize=";

export const REST_API_GET_CLOSE_JOBS_BY_LIST = "job/closed?pageSize=";
export const REST_API_GET_CLOSE_JOBS_BY_FILTER = "job/closed/filter?pageSize=";
export const REST_API_GET_CLOSE_JOBS_BY_SEARCH = "job/closed/search?pageSize=";

//meeting details

export const REST_API_CALL_BACK = "callback/";

//submitfeedback
export const REST_API_SUBMIT_FEEDBACK = "feedback/submit";
//
export const PROFILE_DETAIL_JOB = "security/profiledetail";

//recruiter candidate Job Mapping
export const REST_API_RECRUITER_CANDIDATE_JOB_MAPPING =
  "recruiter/candidate/candidatejobmapping";
export const REST_API_RECRUITER_GET_CANDIDATE_JOB_MAPPING =
  "recruiter/candidate/getcandidatejobmapping";
export const REST_API_RECRUITER_DELETE_CANDIDATE_JOB_MAPPING =
  "recruiter/candidate/deletecandidatejobmapping";
export const REST_API_RECRUITER_GET_JOB_CANDIDATE_MAPPING =
  "recruiter/job/getjobcandidatemapping";
// getting open jobs in view candidate

export const REST_API_GET_OPEN_JOBS = "job/open";
export const REST_API_GET_UNMAPPED_JOBS = "job/unmapped";

//get interview round
export const REST_API_GET_INTERVIEW_ROUNDS = "recruitment/interview/rounds";

export const REST_API_GET_INTERVIEW_RECORDINGS = "recruitment/interview";

//Job operations
export const REST_API_RECRUITER_GET_MATCHING_CANDIDATE =
  "recruiter/job/matchingcandidate";
export const REST_API_RECRUITER_GET_SIMILAR_JOB = "recruiter/job/similarjob";
export const REST_API_RECRUITER_DELETE_JOB_CANDIDATE_MAPPING =
  "recruiter/job/deletejobcandidatemapping";
export const REST_API_RECRUITER_SET_JOB_CANDIDATE_MAPPING =
  "recruiter/job/jobcandidatemapping";
//update job mapped candidate
export const REST_API_UPDATE_JOB_MAPPED_CANDIDATE =
  "candidate/recruitment/updateMappedCandidate";
export const REST_API_CLOSE_JOB = `job/modifyjob?date=${""}&jobId=`;
export const REST_API_EXTEND_JOB = "job/modifyjob?date=";

export const REST_API_GOOGLE_JOB_DETAILS = "job/googlejobs?jobId=";
export const REST_API_ADD_CANDIDATE = "account/recruitment/apply";

//candidate interest reminder
export const REST_API_SEND_CANDIDATE_REMINDER = "job/send/reminder";

//career info
export const REST_API_GET_CAREER_INFO = "careerinfo/get/";
export const REST_API_EDIT_CAREER_INFO = "careerinfo/save/";
export const REST_API_GET_CAREER_PAGE = "configuration/careerpage";
export const REST_API_GET_CAREER_PAGE_DEFAULT =
  "configuration/careerpage/default";

//candidate listing
export const CADIDATE_SEARCH_URL = "searchandmatch/booleansearch?";

// Job Portal - Matching Score
export const REST_API_GET_JOB_PORTAL_CANDIDATES =
  "searchandmatch/jobportal/candidates?";
export const REST_API_POST_GENERATE_MATCHING_SCORE =
  "searchandmatch/match/calculate?";

//candidate normal search listing
export const CANDIDATE_NORMAL_SEARCH = "searchandmatch/simplesearch/";
export const JOB_INACTIVE_SEARCH = "job/inactive/jobSearch?";
export const CANDIDATE_BOOLEAN_SEARCH = "searchandmatch/booleansearch";
// Mapped candidate normal search listing
export const MAPPED_CANDIDATE_NORMAL_SEARCH =
  "organization/searchmappedcandidate/";

export const APPLIED_CANDIDATE_NORMAL_SEARCH =
  "organization/searchmappedcandidatepool/";

export const REST_API_GET_CALENDAR_EVENTS = "interview/company/all";

//cupdate screen candidate  Details

export const REST_API_ADD_SHORTLIST_MANAGER = "configuration/manager/shortlist";

export const REST_API_UPDATE_SHORTLIST_CANDIDATE_DATA =
  "candidate/recruitment/shortlist/edit";

export const REST_API_POST_ABOUT_INTERVIEW = "recruitment/interview";

//Interwer feedback
export const REST_API_INTERVIEWER_VERIFY_CODE =
  "account/interviewer/verification";
export const REST_API_INTERVIWER_FEEDBACK = "account/feedback/interview/status";

//shortlist feedback
export const REST_API_SHORTLIST_VERIFY_CODE =
  "account/shortlist/feedback/verification";
export const REST_API_SHORTLIST_FEEDBACK = "account/feedback/shortlist/submit";

//shortListingCandidatesList
export const REST_API_SHORTLIST_CANDIDATES = "account/feedback/shortlist";

export const REST_API_CANDIDATES_MODAL_DETAILS =
  "account/feedback/shortlist/candidate/details";

//candidate interview feedback
export const REST_API_CANDIDATE_INTERVIEW = "account/feedback/interview";

// hire candidate list
export const REST_API_HIRE_CANIDIDATE_LIST =
  "account/feedback/hire/candidate/list";

export const REST_API_HIRE_SUBMIT = "account/feedback/hire/submit";

export const REST_API_SUBMIT_HIRE_FEEDBACK =
  "account/feedback/hire/submit/details";

//offer listing pagr
export const REST_API_OFFER_LETTER_LIST = "recruitment/offer/list";

//shortlist submitStatus
export const REST_API_SHORTLIST_SUBMIT_STATUS =
  "account/feedback/shortlist/submit/details";

//interviewer submitstatus
export const REST_API_INTERVIEWER_STATUS =
  "account/feedback/interview/submit/details";

//hiredecision
export const REST_API_HIRE_DECISION_LIST = "configuration/hire/decision";

export const REST_API_Offer = "account/feedback/offer?code=";

export const REST_API_POST_OFFER_DATA = "account/feedback/offer";

//getInterviewersList feedback
export const REST_API_INTERVIEWER_DETAILS = "account/feedback/interview/list";

//getInterviewersList feedback
export const REST_API_INTERVIEW_QUESTION_DETAILS =
  "account/feedback/interview/question";

//getInterviewersList feedback
export const REST_API_INTERVIEW_QUESTION_BY_DETAILS =
  "account/feedback/interview/question/review/id";

//getInterview review List feedback
export const REST_API_INTERVIEW_REVIEW_QUESTION_DETAILS =
  "account/feedback/interview/question/review";

//getHIRING InterviewersList feedback
export const REST_API_HIRING_INTERVIEWER_LIST =
  "account/feedback/hire/interview/list";

//get candidatedata interviewer feedback
export const REST_API_CANDIDATE_DATA = "account/feedback/candidate/details";

//get hiring feedback page Candidate list
export const REST_API_HIRING_CANIDATE_DETAILS =
  "account/feedback/hire/candidate/details";

//get shortListData feedback
export const REST_API_SHORTLIST_DATA = "account/feedback/screen/details";

//get hiring shortlist

export const REST_API_HIRING_SHORTLIST_DATA =
  "account/feedback/hire/screen/details";

export const REST_API_CANDIDATE_RESUME_DATA = "account/feedback/view/candidate";

//hire feedback page canidate modal details
export const REST_API_HIRE_FEEDBACK_PAGE_CANDIDATE_MODAL =
  "account/feedback/hire/view/candidate";

//bulkimport suggestion
export const REST_API_BULK_IMPORT_SUGGESTION = "job/bulkimport/suggestion";
//add location dropdown
export const REST_API_ADD_LOCATION = "job/addlocation";

export const REST_API_UPDATE_CANDIDATE_MAPPING_STATUS =
  "candidate/recruitment/mapping/status/update";

export const REST_API_POST_PREVIEW_CAREER_PAGE =
  "configuration/careerpage/preview";
export const REST_API_VERIFY_ACCESS_TOKEN = "security/verifytoken";

// suggestion
export const REST_API_JOB_LOCATION_SUGGESTION = "job/autoComplete/location?";
export const REST_API_JOB_JOBPROFILE_SUGGESTION =
  "job/autoComplete/jobProfile?";

export const SEARCH_SUGGESTION_DATA = "searchandmatch/autocomplete";

export const SEARCH_TABLE_SUGGESTION_DATA = "account/taxonomy/autocomplete";

export const REST_API_RECRUITMENT_CANDIDATE_DETAIL =
  "recruitment/screen/candidate?";

export const REST_API_TEMPLATE_LIST = "config/template/list";

export const REST_API_TEMPLATE = "config/template";

export const REST_API_GET_TEMPLATE = "config/template?id=";

export const REST_API_TEMPLATE_PREVIEW = "config/template/process/createpdf";

export const REST_API_TEMPLATE_SAMPLE = "config/template/sample";

//email template
export const REST_API_EMAIL_TEMPLATE_TITLE = "configuration/email/title";
export const REST_API_EMAIL_TEMPLATE_ADD = "configuration/email";

//get hire Candidate Data
export const REST_API_GET_HIRE_CANDIDATE_DATA = "recruitment/hire?";
//save hire candidate data
export const REST_API_GET_SAVE_HIRE_CANDIDATE_DATA = "recruitment/hire";

//offer letter template
export const REST_API_TEMPLATE_OFFER_LETTER = "config/template/list";

//
export const REST_API_TIME_LINE_DETAIL = "process/timeline?";
export const REST_API_SEND_REMINDER = "recruitment/send/reminder?";
export const REST_API_SHOW_OFFER_LETTER = "recruitment/offer/permission?jobId=";

export const REST_API_GET_RECRUITER_CLIENTS = "recruiter/company";
export const REST_API_GET_RECRUITER_CLIENTS_DOWNLOAD =
  "recruiter/company/download";
export const REST_API_GET_RECRUITER_CLIENTS_STATUS = "recruiter/company/status";
export const REST_API_GET_ONE_COMPANY_DETAILS = "recruiter/company/id?id=";

//admin-organization
export const REST_API_GET_ADMIN_ORGANIZATION_LIST = "admin/organization";
export const REST_API_POST_ADMIN_CLIENT = "admin/organization";
export const REST_ADMIN_API_GET_ONE_COMPANY_DETAILS = "admin/organization/";
export const REST_API_GET_ADMIN_CLIENTS_STATUS = "admin/organization";

//admin userManger
export const REST_API_GET_ADMIN_USERS_DATA_LIST = "admin/user/list";
export const REST_API_ADD_NEW_USER_DATA = "admin/user";
export const REST_API_GET_ADMIN_USERS = "admin/user";

//admin report
export const REST_API_ADMIN_POSTED_JOBS = "admin/report/totalJobs";

export const REST_API_GET_VIDEO_LIST = "admin/video";
export const REST_API_VIDEO_DELETE = "admin/video/delete";

//job Status
export const REST_API_GET_JOB_ACTIVE = "job/status?jobId=";
export const REST_API_GET_REQUIRED_FIELDS =
  "recruitment/validation?candidateId=";
export const REST_API_POST_MODAL_POPUP = "recruitment/validation";

export const REST_API_ASSESMENT_QUESTION = "interview/questionaire";
export const REST_API_DOCUMENTS = "configuration/documents";
export const REST_API_VERIFY_DOCUMENTS = "recruitment/verification/document";
export const REST_API_GET_ASSESMENT_SHEET_LIST = "interview/questionaire/list";
export const REST_API_CHANGE_THE_STATUS =
  "interview/questionaire/status?questionaireId=";
export const REST_API_GET_THE_SHEET_DATA =
  "interview/questionaire/data?questionnaireId=";

export const REST_API_ASSESMENT_SUGGESTION =
  "interview/questionaire/suggestion/questions?keyword=";
export const REST_API_DOCUMENTS_LIST = "account/feedback/document?code=";
export const REST_API_POST_DOCUMENTS = "account/feedback/document";

//hireneuron video meeting token verify end-point
export const REST_API_MEETING_TOKEN_VERIFY = "account/zegocloud/token";

// for impersonate
export const REST_API_IMPERSONATE_LOGIN = "admin/impersonate/login";

export const REST_API_QUESTION_BANK = "configuration/assessment/questionBank";
export const REST_API_WORKFLOW = "configuration/assessment/workflow";

export const REST_API_CANDIDATE_ASSESSMENT_STATUS = "recruitement/assessment";

//UnsubscribedEmail
export const REST_API_UNSUBSCRIBED_EMAIL = "webhook/email/unsubscribe";
//subscribedEmail
export const REST_API_SUBSCRIBED_EMAIL = "webhook/email/subscribe";

export const REST_API_GET_CSV_FILE_JOB = "job/migration";
export const REST_API_GET_CSV_FILE_CANDIDATE = "candidate/migration";

export const REST_API_THIRDPARTYAPP = "configuration/app";

export const REST_API_GET_JOB_INDUSTRIES = "bank/jobIndustry";
export const REST_API_GET_JOB_DEGREES = "bank/degree";

//domain manegement

export const REST_API_GET_DOMAIN_DATA =
  "configuration/careerpage/domainmanagement";

export const REST_API_SHORTLIST_MANAGERS = "configuration/manager/shortlist";
export const REST_API_INTERVIEWERS = "configuration/manager/interviewer";

export const REST_API_MIGRATION = "migration/csv/mapping";
export const REST_API_MIGRATION_DATA = "migration/csv";
export const REST_API_MIGRATION_STATUS = "migration";

//CAREER POP UP
export const REST_API_CAREER_CONFIG_DATA = "security/profile/configuration";
export const REST_API_UPDATE_CAREERPAGEURL = "security/profile/careerpage";
// update career page integration link
export const REST_API_UPDATE_INTEGRATION_CAREERPAGELINK =
  "security/profile/add/careerpagelink";
export const REST_API_HIDE_CAREERPAGEPOPUP = "security/profile/hidepopup";
export const REST_API_ZOHO_ACCESS = "callback/zoho";
export const REST_API_ZOHO_PROCESS = "zoho/process";
export const REST_API_ZOHO_ACCESS_LOGOUT = "callback/zoho/logout";
export const REST_API_EMAIL_INTEGRATION = "email";
export const REST_API_SET_JOB_CANDIDATE_MAPPING = "recruitment";
//get recruitment report
export const REST_API_OTHER_JOB_DETAILS = "recruitment/report?jobId=";

//screen
export const REST_API_GET_SCREEN_CANDIDATE_DATA =
  "recruitment/screen/candidate";
export const REST_API_MAP_CANDIDATE = "recruitment/mapping";
export const REST_API_GET_MAPPED_CANDIDATES = "recruitment/mapping/candidate";
export const REST_API_GET_MAPPED_CANDIDATES_COUNT =
  "recruitment/mapping/candidate/count";
export const REST_API_RECRUITMENT = "recruitment";
//shortlist
//get shortlisted candidate data
export const REST_API_GET_SHORTLIST_CANDIDATE_DATA = "recruitment/shortlist";
//get manager list
export const REST_API_GET_MANAGERS_LIST = "recruitment/shortlist/manager";
// change shortlist manager
export const REST_API_MOVE_TO_SHORTLIST =
  "recruitment/shortlist/manager/change";
// update shortlist (move to interview/reject)
export const REST_API_UPDATE_SHORTLIST = "recruitment/shortlist/update";
//Interview
//get scheduler interview data
export const REST_API_GET_SCHEDULE_INTERVIEWS =
  "recruitment/interview/scheduled";
//post interview round
export const REST_API_POST_ADD_INTERVIEW_ROUND = "recruitment/interview/round";
//schedule interview round
export const REST_API_SCHEDULE_INTERVIEW = "recruitment/interview";
//update interview details
export const REST_API_SCHEDULE_INTERVIEW_UPDATE =
  "recruitment/interview/update";
export const REST_API_GET_INTERVIEWERS = "interviewer/list";
export const REST_API_ADD_INTERVIEWER = "interviewer/save";
export const REST_API_RESCHEDULE_INTERVIEW = "interview/reschedule";

//candidate Interview Details
export const REST_API_GET_CANDIDATE_INTERVIEW_DETAILS =
  "interview/candidate/all?candidateId=";
export const REST_API_POST_CANDIDATE_STAGE = "interview/mapping/status/change";
export const REST_API_POST_CURRENT_CANDIDATE_STATUS =
  "interview/mapping/status/get";
export const REST_API_POST_CANDIDATE_FEEDBACK = "interview/feeback/submit";
export const REST_API_GET_CANDIDATE_COMMENT_LIST =
  "candidate/comment?commentType=INTERVIEW&candidateId=";
export const REST_API_POST_COMMENT_ON_CANDIDATE = "candidate/comment/add";

export const REST_API_GET_ALL_INTERVIEWS =
  "interview/interviewall?pageSize=10&page=";
//delete interview round
export const REST_API_DELETE_INTERVIEW = "recruitment/interview";
//reject candidate from interview stage
export const REST_API_REJECT_CANDIDATE = "recruitment/interview/stage";

//Offer
//get offer details
//gen offer letter
export const REST_API_GEN_OFFER_LETTER = "recruitment/offer";
//revoke offerletter
export const REST_API_FOR_EDIT_OFFER_LETTER = "recruitment/offer/revoke";
export const REST_API_REPORTS = "report/candidate/master";
export const REST_API_JOB_REPORTS = "report/job/master";
export const REST_API_JOB_PERFORMANCE_REPORTS = "report/job/performance";
//career page integration
export const REST_API_FETCH_CAREER_PAGE_REGISTRATION = "admin/careerpage";
//open api
export const REST_API_FETCH_OPENAPI_REGISTRATION = "admin/open/api";

//candidate delete from pop
export const REST_DELETE_CANDIDATE = "candidate/delete";
//linkedin job posting
export const LINKEDIN_VALIDATION_TOKEN = "callback/validate";
export const LINKEDIN_SAVE_ORG_ID = "callback/save/company";

export const REST_API_GET_MATCHING_CANDIDATES = "searchandmatch/match/list";
export const REST_API_GET_JOBPORTAL_CANDIDATES =
  "searchandmatch/jobportal/candidates?";
